import styled, { css } from "styled-components";
import { THEME_SECONDARY } from "./constants";

const primaryTheme = css`
  background: transparent;
  border: none;
  border-radius: 5px;
  color: #7a7a7a;
  cursor: pointer;
  font-weight: 500;
  padding: 20px 0;
  transition: all 0.2s;
  width: 100%;

  &:hover {
    background: #a9b2b6;
    color: white;
  }

  &:disabled {
    color: #a2a7b3;
    cursor: not-allowed;
  }
`;

const secondaryTheme = css`
  align-items: center;
  background: white;
  border-radius: 4px;
  border: 1px solid rgba(128, 128, 128, 0.15);
  color: blue;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 15px;
  font-weight: 400;
  gap: 8px;
  height: 50px;
  justify-content: center;
  margin-right: 20px;
  padding: 14px 20px;
  user-select: none;
  width: 200px;

  &:hover {
    background: white;
    color: #444;
  }

  &:disabled {
    color: #a2a7b3;
    cursor: not-allowed;
  }
`;

function getTheme(theme) {
  if (theme === THEME_SECONDARY) {
    return secondaryTheme;
  }

  return primaryTheme;
}

export const DraftButton = styled.button`
  font-size: 15px;
  ${(props) => getTheme(props.theme)}
`;
